import { render, staticRenderFns } from "./StudentStatistics.vue?vue&type=template&id=403642e5&scoped=true&"
import script from "./StudentStatistics.vue?vue&type=script&lang=js&"
export * from "./StudentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./StudentStatistics.vue?vue&type=style&index=0&id=403642e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403642e5",
  null
  
)

export default component.exports